import React, {ReactElement, useCallback, useState} from 'react';
import {Collapse} from 'react-collapse';
import {FormattedMessage} from 'react-intl';
import {ReactComponent as IconDown} from 'assets/image/library/chevron-down.svg';
import {ReactComponent as IconUp} from 'assets/image/library/chevron-up.svg';

import './styles.scss';

type LocationsProps = {
  children?: ReactElement | null;
};

export const Locations = ({
  children
}: LocationsProps): JSX.Element => {
  const [isCollapseOpen, setIsCollapseOpen] = useState(true);

  const onClick = useCallback(
    () => setIsCollapseOpen(!isCollapseOpen),
    [isCollapseOpen]
  );

  return <div className="locations">
    <button className="locations__header" aria-expanded={isCollapseOpen} onClick={onClick}>
      <div className="locations__title">
        <FormattedMessage
          id={'gritx.resource.locations.header'}
          defaultMessage={'What locations should we show?'}
        />
      </div>
      {isCollapseOpen ? <IconUp className="locations__arrow" /> : <IconDown className="locations__arrow" />}
    </button>
    <Collapse
      isOpened={isCollapseOpen}>
      <div className="locations__content">{children}</div>
    </Collapse>
  </div>;
};
